module.exports = __webpack_public_path__ + "static/media/timer.dd83cda5.svg";